module.exports = __webpack_public_path__ + "media/images/icon_close-452cb4cc3fbd675e68ee2bfddcee44b1.png";